module.exports = __webpack_public_path__ + "img/aging.ed933fa2.svg";